import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { FormChangedGuard } from './form-changed-guard/form-changed-guard';
import { StartPageCardEditPageComponent } from '../pages/cms/startPage/start-page-card-block/start-page-card-edit-page/start-page-card-edit-page.component';

@Injectable({
  providedIn: 'root',
})
export class StartPageEditCardFormChangedGuard
  extends FormChangedGuard
  implements CanDeactivate<StartPageCardEditPageComponent>
{
  canDeactivate(
    component: StartPageCardEditPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return component.tileForm
      ? this.handleNavigation(
          component.hasUnsavedChanges(component.tileForm),
          nextState.url,
          () => component.resetFormChanges
        )
      : false;
  }
}
